export default "__VITE_ASSET__CY2Atptb__"